import CircularProgress from '@mui/material/CircularProgress';
import {
  Box,
  Button,
  Dialog,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  Stack,
  IconButton,
  Tooltip,
  InputBase,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { poppins400, poppins500 } from 'theme/common.style';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { useContext, useEffect, useState, useRef } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {
  Moxoseparationinlisting,
  postApiCall,
  formatDepositDate,
} from 'api/apiService';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { REQUEST_DEPOSIT } from 'constant/app.config';
import dayjs from 'dayjs';
import { Calendarimg } from 'component/OwnerCard/NotesTasks';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import SelectBuyerTable from './StatusDetailsPopups/SelectBuyerTable';
import searchIcon from 'assets/svg/searchIcon.svg';
import Loading from 'assets/images/loading.png';
import AgencyBadge from 'component/Common/AgencyBadge';
import NameTooltip from 'component/Common/NameTooltip';

const CrossIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3409 8.32196C15.7449 7.9454 15.7672 7.31263 15.3906 6.90862C15.0141 6.5046 14.3813 6.48234 13.9773 6.85889L11.0512 9.58611L8.32391 6.65999C7.94735 6.25598 7.31458 6.23372 6.91057 6.61027C6.50655 6.98682 6.48429 7.61959 6.86084 8.02361L9.58806 10.9497L6.66194 13.677C6.25793 14.0535 6.23567 14.6863 6.61222 15.0903C6.98877 15.4943 7.62154 15.5166 8.02556 15.14L10.9517 12.4128L13.679 15.3389C14.0555 15.7429 14.6883 15.7652 15.0923 15.3886C15.4963 15.0121 15.5186 14.3793 15.142 13.9753L12.4148 11.0492L15.3409 8.32196Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20Z"
        fill="white"
      />
    </svg>
  );
};

export default function RequestDepositPaymentPopup(props) {
  const {
    openRequestDeposit,
    depositDetailsData,
    setOpenRequestDeposit,
    buyerId,

    profileDetails,
    isAllBuyer,
    getDetailsData,
    fromMiddleContent,
    getTableData,
    isFromBuyerRegister,
    getListInfo,
    manageOfferClick,
    fromVendorStatus,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const flexStyle = {
    display: 'flex',
    flexDirection: matchessm ? 'column' : 'row',
    alignItems: 'center',
    gap: '15px',
  };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches400 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };
  const params = useParams();

  const CopyIcon = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_36034_154632)">
          <path
            d="M7 6V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V17C21 17.2652 20.8946 17.5196 20.7071 17.7071C20.5196 17.8946 20.2652 18 20 18H17V21C17 21.552 16.55 22 15.993 22H4.007C3.87513 22.0008 3.7444 21.9755 3.62232 21.9256C3.50025 21.8757 3.38923 21.8022 3.29566 21.7093C3.20208 21.6164 3.12779 21.5059 3.07705 21.3841C3.02632 21.2624 3.00013 21.1319 3 21L3.003 7C3.003 6.448 3.453 6 4.01 6H7ZM5.003 8L5 20H15V8H5.003ZM9 6H17V16H19V4H9V6Z"
            fill="#C4C4C4"
          />
        </g>
        <defs>
          <clipPath id="clip0_36034_154632">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const { setDisplayExchange, setOpenManageOfferFromVendorStatus } =
    useContext(PropertyContext);

  const [formattedTotalAmount, setFormattedTotalAmount] = useState('');
  const [accnocopied, setAccNoCopied] = useState(false);
  const [percentDis, setPercentDis] = useState(false);
  const [amountDis, setAmountDis] = useState(false);
  const [bsbcopied, setBsbCopied] = useState(false);
  // const [depositRes, setDepositRes] = useState('');
  const [contractAprove, setContractAprove] = useState(false);
  const [depositDue, setDepositDue] = useState();
  const [depositAmount, setDepositAmount] = useState();
  const [accountcopied, setAccountCopied] = useState(false);
  const [depositSettlement, setDepositSettlement] = useState();
  const [FromOgDate, setFromOgDate] = useState();
  const [depositSettleErr, setDepositSettleErr] = useState(false);
  const [depositPercent, setDepositPercent] = useState();

  const [selectBuyerError, setSelectBuyerError] = useState(false);
  const [depositAmtErr, setDepositAmtErr] = useState(false);
  const [amount, setAmount] = useState(0);
  const [depositDueErr, setDepositDueErr] = useState(false);

  const [selectedBuyerData, setSelectedBuyerData] = useState({});

  const buyerData = depositDetailsData?.depositDetails;
  const selectedBuyerDetails = selectedBuyerData?.depositDetails;
  const agentAgencyName =
    selectedBuyerData?.depositDetails?.agentAgencyName ||
    depositDetailsData?.depositDetails?.agentAgencyName;
  const stageTwo = profileDetails?.PropertyDetails?.stage === 'ST2';
  const today = dayjs().tz('Australia/Sydney').startOf('day');

  const buyerName = isAllBuyer
    ? selectedBuyerDetails
      ? `${selectedBuyerDetails?.buyerName ?? ''} ${
          selectedBuyerDetails?.buyerSurName ?? ''
        }`.trim()
      : null
    : buyerData
    ? `${buyerData?.buyerName ?? ''} ${buyerData?.buyerSurName ?? ''}`.trim()
    : null;

  const propertyAddress =
    buyerData?.propertyAddress ||
    profileDetails?.PropertyDetails?.propertyAddress?.streetName;
  const offerPrice =
    buyerData?.formattedOfferPrice || selectedBuyerDetails?.formattedOfferPrice;
  const offerPriceValue =
    buyerData?.offerPrice || selectedBuyerDetails?.offerPrice;

  const updatedSettlementDays = isAllBuyer
    ? selectedBuyerDetails?.settlementDays
    : buyerData?.settlementDays;
  const updatedPercentage = isAllBuyer
    ? Number(selectedBuyerDetails?.depositPercentage)
    : Number(buyerData?.depositPercentage);

  useEffect(() => {
    setDepositSettlement(
      updatedSettlementDays || profileDetails?.PropertyDetails?.settlementDays
    );
    setDepositPercent(
      updatedPercentage || profileDetails?.PropertyDetails?.percentage
    );
  }, [openRequestDeposit, selectedBuyerDetails]);

  const paidAmount = selectedBuyerDetails?.paid ?? 0;

  const AlreadyHeldAmount = isAllBuyer
    ? selectedBuyerDetails?.alreadyHeldFormatted
    : buyerData?.alreadyHeldFormatted;
  const ReceivedDate = isAllBuyer
    ? selectedBuyerDetails?.receivedDate
    : buyerData?.receivedDate;
  const AlreadyRequested = isAllBuyer
    ? selectedBuyerDetails?.alreadyHeldRequestFormatted
    : buyerData?.alreadyHeldRequestFormatted;
  const AlreadyTransferred = isAllBuyer
    ? selectedBuyerDetails?.alreadyHeldTransferFormatted
    : buyerData?.alreadyHeldTransferFormatted;

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForDepositBuyerAck))
      Moxoseparationinlisting(
        'dataForDepositBuyerAck',
        res?.data?.dataForDepositBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //2
  };

  const isFormValid = isAllBuyer
    ? buyerName?.length &&
      selectBuyerError == false &&
      depositAmount &&
      !depositAmtErr &&
      !!depositDue &&
      !depositDueErr &&
      !!depositSettlement
    : depositAmount &&
      !depositAmtErr &&
      !!depositDue &&
      !depositDueErr &&
      !!depositSettlement;

  const colseContractAprove = () => {
    setSelectedBuyerData({});
    setContractAprove(false);
    setOpenRequestDeposit(false);
    setOpenRequestDeposit(false);
    setSelectBuyerError(false);
    setDepositAmtErr(false);
    setDepositDueErr(false);
    setDepositSettleErr(false);
    setDepositAmount('');
    setDepositPercent('');
    setAmount(0);
    setDepositDue(null);
    setFromOgDate(null);
    setDepositSettlement('');
  };

  const [requestDepositLoader, setRequestdepositLoader] = useState(false);

  const RequestBuyerId = isAllBuyer ? selectedBuyerDetails?.buyerId : buyerId;
  const PropertyId = params?.dashboardId;

  const reqdeposit = () => {
    setRequestdepositLoader(true);
    const commonDepositData = {
      buyerId: Number(RequestBuyerId),
      propertyId: Number(PropertyId),
      isConfirmDeposit: 0,
      depositAmount: depositAmount,
      amountIn: Number(depositPercent),
      settlementDays: depositSettlement,
      dueDate: depositDue,
      trustAccName: 'AJ Real Estate Trust Account',
      bsb: '0191928',
      accNo: '019021928',
      depositType: 'EFT',
    };

    const resetFormState = () => {
      setSelectBuyerError(false);
      // setOpenRequestDeposit(false);
      setSelectedBuyerData({});
      setDepositAmount('');
      setDepositPercent('');
      setFormattedTotalAmount('');
      setAmount(0);
      setDepositDue(null);
      setFromOgDate(null);
      setDepositSettlement('');
    };

    postApiCall(REQUEST_DEPOSIT, commonDepositData).then((res) => {
      resetFormState();

      if (res?.data?.status == '1') {
        moxoapis(res);
        getListInfo();
        setRequestdepositLoader(false);
        if (fromMiddleContent) getDetailsData();
        if (!isFromBuyerRegister) {
          getTableData();
        }

        Swal.fire({
          title: res?.data?.heading || 'Requested',
          html: `The deposit payment has been requested <br /> from <b style="font-family: Poppins; font-weight: 550; color:#666666;">${buyerName}</b>.`,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          setOpenRequestDeposit(false);
          setDisplayExchange(true);
        });
      } else {
        setRequestdepositLoader(false);
        Swal.fire({
          title: res?.data?.heading || 'Error',
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then(() => {
          setDisplayExchange(true);
          setDepositSettlement(depositSettlement);
        });
      }
    });
  };

  const reqdepositvalidate = () => {
    if (!selectedBuyerData?.length) {
      setSelectBuyerError(true);
    }
    if (depositAmtErr) return;
    if (!depositDue) {
      setDepositDueErr(true);
    } else {
      setDepositDueErr(false);
    }
    if (!depositSettlement) {
      setDepositSettleErr(true);
    } else {
      setDepositSettleErr(false);
    }

    if (depositAmount && depositDue && depositSettlement) {
      reqdeposit();
    }
  };

  const handleBsbCopy = () => {
    navigator.clipboard.writeText('019 1928');
    setBsbCopied(true);

    setTimeout(() => {
      setBsbCopied(false);
    }, 2000);
  };

  const handleAccountCopy = () => {
    navigator.clipboard.writeText('AJ Real Estate Trust Account');
    setAccountCopied(true);

    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);
  };

  const handleDepositPercentChange = (e) => {
    let value = e.target.value.replace('%', '');

    value = value.replace(/^0+(?=\d)/, '');

    if (!/^\d*$/.test(value)) return;

    const percentValue = parseInt(value, 10);
    if (percentValue > 100) return;

    const paid = isAllBuyer
      ? selectedBuyerDetails?.alreadyHeldRequested ?? 0
      : buyerData?.alreadyHeldRequested ?? 0;

    // Calculate total expected deposit from percentage
    const expectedDeposit = (percentValue / 100) * offerPriceValue;

    // Subtract already paid
    const remainingDeposit = Math.max(expectedDeposit, 0); // no negative amounts

    const totalPossible = offerPriceValue - paid;
    if (expectedDeposit > totalPossible) {
      setDepositAmtErr(true);
      return;
    }

    if (value && !isNaN(percentValue) && percentValue >= 0) {
      setDepositAmtErr(false);
      setDepositAmount(remainingDeposit);
      setFormattedTotalAmount(remainingDeposit.toLocaleString('en-US'));
    } else {
      setDepositAmount(0);
      setFormattedTotalAmount('');
    }

    setDepositPercent(value);
  };

  useEffect(() => {
    const hasValidData = buyerData || (selectedBuyerDetails && offerPriceValue);

    if (!hasValidData) {
      setDepositPercent('');
      setDepositAmount(0);
      setFormattedTotalAmount('');
      return;
    }

    const percent =
      (updatedPercentage || profileDetails?.PropertyDetails?.percentage) ?? 0;

    const paid = isAllBuyer
      ? Number(selectedBuyerDetails?.alreadyHeldRequested) || 0
      : Number(buyerData?.alreadyHeldRequested) || 0;

    const targetDeposit = (offerPriceValue * percent) / 100;

    const remainingAmount = Math.max(targetDeposit, 0);
    const totalPossible = offerPriceValue - paid;

    if (remainingAmount > totalPossible) {
      setDepositAmtErr(true);
      setDepositAmount(0);
      setFormattedTotalAmount('0');
      return;
    }

    setDepositAmtErr(false);
    setDepositPercent(percent);
    setDepositAmount(remainingAmount);
    setFormattedTotalAmount(remainingAmount.toLocaleString('en-US'));
  }, [
    buyerData,
    selectedBuyerDetails,
    offerPriceValue,
    profileDetails,
    updatedPercentage,
    isAllBuyer,
  ]);

  const [open, setOpen] = useState(false);
  const [toggleState, setToggleState] = useState(true);

  const handleToggleState = () => {
    setToggleState((prev) => !prev);
  };
  const handleIconClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (depositPercent) {
      setAmountDis(true);
    } else {
      setAmountDis(false);
    }
  }, [depositPercent]);

  useEffect(() => {
    if (amount) {
      setPercentDis(true);
    } else {
      setPercentDis(false);
    }
  }, [amount]);

  const handleAccNoCopy = () => {
    navigator.clipboard.writeText('0190 21928');
    setAccNoCopied(true);

    setTimeout(() => {
      setAccNoCopied(false);
    }, 2000);
  };

  const [openBuyerListPopup, setOpenBuyerListPopup] = useState(false);

  const handleOpen = () => {
    setOpenBuyerListPopup(true);
  };
  const handleClose = () => {
    setOpenBuyerListPopup(false);
  };

  const depositInputRef = useRef();

  useEffect(() => {
    if (requestDepositLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [requestDepositLoader]);

  return (
    <Dialog
      open={openRequestDeposit}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matches800 ? '95%' : '800px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          paddingBottom: matches700 && '40px',
          // padding:  matchessm ? "30px 20px" :  "30px",
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid container xs={12} sx={{ padding: '30px' }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {propertyAddress}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Request Deposit Payment
            </Typography>
          </Grid>
          <Grid
            item
            // xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            // paddingTop={'10px'}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                width: 'auto',
                color: '#666666',
              }}
            >
              {isAllBuyer ? (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: 16,
                      color: '#444',
                      lineHeight: 1.6,
                    }}
                  >
                    You are about to send a request to buyer{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {buyerName}
                    </Box>{' '}
                    to make a deposit payment for{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {propertyAddress}
                    </Box>
                    .
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: 16,
                      color: '#444',
                      lineHeight: 1.6,
                    }}
                  >
                    You are about to send a request to buyer{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {buyerName}
                    </Box>{' '}
                    to make a deposit payment for{' '}
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: '#333',
                      }}
                    >
                      {propertyAddress}
                    </Box>
                    .
                  </Typography>
                </>
              )}
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: '1px solid lightgrey', width: '100%' }}></Box>

        {/* {isAllBuyer && ( */}
        <Grid
          container
          direction="column"
          sx={{
            padding: '38px 0 0 31px',
          }}
          rowGap={3}
        >
          {/* First Row - Two Items in Row */}
          <Grid item>
            <Stack direction="row" spacing={4} alignItems="center">
              <Stack
                display={!AlreadyHeldAmount && 'none'}
                direction="row"
                spacing={10}
                alignItems="center"
              >
                <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                  Already Held:
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#000000',
                    fontSize: '16px',
                  }}
                >
                  {AlreadyHeldAmount ?? '-'}
                </Typography>
              </Stack>

              <Stack
                display={!ReceivedDate && 'none'}
                direction="row"
                spacing={6}
                alignItems="center"
              >
                <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                  Received Date:
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#000000',
                    fontSize: '16px',
                  }}
                >
                  {formatDepositDate(ReceivedDate) || '-'}
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {/* Second Row */}
          <Grid item display={!AlreadyRequested && 'none'}>
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                Already Requested:
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  color: '#000000',
                  fontSize: '16px',
                }}
              >
                {AlreadyRequested ?? '-'}
              </Typography>
            </Stack>
          </Grid>

          {/* Third Row */}
          <Grid item display={!AlreadyTransferred && 'none'}>
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography sx={{ ...reqStyle, whiteSpace: 'nowrap' }}>
                Already Transferred:
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  color: '#000000',
                  fontSize: '16px',
                }}
              >
                {AlreadyTransferred ?? '-'}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
        {/* )} */}

        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '20px',
            margin: '30px',
          }}
        >
          <Grid xs={12}>
            <Typography
              sx={{
                fontFamily: 'poppins',
                fontSize: '24px',
                fontWeight: 400,
              }}
            >
              Deposit Details
            </Typography>
          </Grid>
          <Grid xs={12} sx={flexStyle}>
            <Typography sx={reqStyle} mb={matchessm ? '20px' : '0'}>
              Buyer Name:
            </Typography>
            {isAllBuyer ? (
              <Grid item>
                {selectedBuyerDetails?.buyerName ? (
                  <>
                    <Button
                      sx={{
                        position: 'relative', // for absolutely positioning the icon
                        fontSize: matchessm ? '11px' : '13px',
                        fontWeight: 600,
                        fontFamily: 'poppins',
                        paddingLeft: '2px',
                        borderRadius: 6,
                        backgroundColor: '#A55FFB',
                        color: '#FFFFFF',
                        padding: matchessm
                          ? '4px 60px 4px 8px'
                          : '8px 36px 8px 12px', // right padding to make space for icon
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        textTransform: 'capitalize',
                        minWidth: matchessm ? '50px' : '153px',
                        '&:hover': {
                          backgroundColor: '#A55FFB',
                        },
                      }}
                    >
                      {selectedBuyerDetails?.buyerName +
                        ' ' +
                        selectedBuyerDetails?.buyerSurName}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedBuyerData({});
                        }}
                        sx={{
                          position: 'absolute',
                          right: matchessm ? 4 : 8,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontSize: matchessm ? '14px' : '16px',
                          padding: 0,
                          color: '#fff',
                          backgroundColor: 'transparent',
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        <CrossIcon
                          sx={{
                            fontSize: matchessm ? '14px' : '16px',
                          }}
                        />
                      </IconButton>
                    </Button>
                  </>
                ) : (
                  <>
                    <Stack direction={'column'}>
                      <Box
                        component="form"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#F2F2F2',
                          borderRadius: '30px',
                          width: '236px',
                          height: '32px',
                          border: selectBuyerError && '1px solid red',
                        }}
                        onClick={handleOpen}
                      >
                        <IconButton
                          disabled
                          sx={{ p: '7px', paddingLeft: '20px' }}
                          aria-label="search"
                        >
                          <img alt="searchIcon" src={searchIcon} />
                        </IconButton>

                        <InputBase
                          sx={{
                            ml: 1,
                            flex: 1,
                            '& input::placeholder': {
                              color: '#666666 !important',
                              fontSize: '12px',
                              fontWeight: 400,
                              fontFamily: 'poppins',
                              opacity: 1,
                            },

                            fontSize: '12px',
                            fontWeight: 400,
                            fontFamily: 'poppins',
                          }}
                          placeholder="Search Buyer"
                          inputProps={{
                            'aria-label': 'Search Buyer',
                          }}
                        />
                      </Box>
                      <Typography
                        style={{
                          visibility: selectBuyerError ? 'visible' : 'hidden',
                          color: 'red',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                        }}
                      >
                        Select offered buyer
                      </Typography>
                    </Stack>
                    <SelectBuyerTable
                      openBuyerListPopup={openBuyerListPopup}
                      setOpenBuyerListPopup={setOpenBuyerListPopup}
                      profileDetails={profileDetails}
                      setSelectedBuyerData={setSelectedBuyerData}
                    />
                  </>
                )}
              </Grid>
            ) : (
              <>
                <Box
                  sx={{
                    flex: '0 1 auto',
                    minWidth: 0,
                    maxWidth: 'calc(100% - 160px)',
                    overflow: 'hidden',
                  }}
                >
                  <NameTooltip name={buyerName || ''}>
                    <Typography
                      component="span"
                      sx={{
                        display: 'block',
                        width: '100%',
                        minWidth: 0,
                        fontFamily: 'Poppins',
                        color: '#000000',
                        fontSize: '16px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer',
                      }}
                    >
                      {buyerName}
                    </Typography>
                  </NameTooltip>
                </Box>

                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#2488d5',
                    fontSize: '16px',
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (fromVendorStatus || isFromBuyerRegister) {
                      setOpenManageOfferFromVendorStatus({
                        open: true,
                        buyerId: buyerId,
                      });
                    } else {
                      manageOfferClick();
                    }
                  }}
                >
                  View current offer
                </Typography>
              </>
            )}
          </Grid>
          {offerPrice && (
            <Grid xs={12} sx={flexStyle}>
              <Typography sx={reqStyle}>Offer Amount:</Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  color: '#000000',
                  fontSize: '16px',
                  marginLeft: matches400 && '30px',
                }}
              >
                {offerPrice}
              </Typography>
            </Grid>
          )}

          <Grid
            xs={12}
            sx={flexStyle}
            style={{ flexWrap: matches400 ? 'wrap' : 'nowrap' }}
          >
            <Typography sx={reqStyle}>Deposit Amount:</Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: {
                  xs: '100%', // Full width on mobile
                  sm: '80%',
                  md: '65%',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: {
                    xs: 'column', // Stack inputs vertically on mobile
                    sm: 'row',
                  },
                  alignItems: {
                    xs: 'flex-start',
                    sm: 'center',
                  },
                  gap: '15px',
                  flexWrap: 'wrap',
                }}
              >
                <TextField
                  variant="outlined"
                  error={depositAmtErr}
                  disabled={!buyerName}
                  // placeholder="%"
                  inputProps={{
                    maxLength: 3,
                    style: { fontFamily: 'Poppins', padding: 9 },
                  }}
                  style={{
                    opacity: percentDis && 0.5,
                    pointerEvents: percentDis && 'none',
                  }}
                  value={depositPercent}
                  onChange={handleDepositPercentChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        sx={{
                          justifyContent: { xs: 'center', sm: 'flex-end' },
                        }}
                      >
                        <Typography
                          sx={{
                            background: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: { xs: '12px', sm: '14px', md: '16px' },
                            fontWeight: 600,
                            fontFamily: 'Poppins',
                          }}
                        >
                          %
                        </Typography>
                      </InputAdornment>
                    ),
                    sx: {
                      fontSize: {
                        xs: '14px',
                        sm: '16px',
                        md: '20px',
                      },
                      textAlign: 'center',
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: {
                        xs: '14px',
                        sm: '16px',
                        md: '20px',
                      },
                      textAlign: 'center',
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                    },
                  }}
                  sx={{
                    width: {
                      xs: '100%',
                      sm: '85px',
                    },
                    height: '50px',
                    display: 'flex',
                    alignItems: 'left',
                    justifyContent: 'center',
                    '& .MuiOutlinedInput-input': {
                      textAlign: 'center',
                      // padding: "15px 14px",
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                    },
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                    },
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: {
                      xs: '16px',
                      sm: '18px',
                      md: '20px',
                    },
                    color: 'lightgrey',
                    textAlign: 'center',
                    width: {
                      xs: '100%',
                      sm: 'auto',
                    },
                  }}
                >
                  OR
                </Typography>

                <TextField
                  variant="outlined"
                  error={depositAmtErr}
                  inputRef={depositInputRef}
                  value={formattedTotalAmount}
                  inputProps={{
                    maxLength: 10,
                    style: { fontFamily: 'Poppins' },
                    pattern: '[0-9]*',
                  }}
                  onChange={(e) => {
                    const input = e.target;
                    const raw = input.value;
                    const cursorPos = input.selectionStart;

                    const newValue = raw.replace(/[^0-9.]/g, '');
                    const depositAmount = parseFloat(newValue) || 0;

                    const paid = isAllBuyer
                      ? selectedBuyerDetails?.alreadyHeldRequested
                      : buyerData?.alreadyHeldRequested ?? 0;

                    const remainingAmount = offerPriceValue - paid;

                    if (depositAmount > remainingAmount) {
                      setDepositAmtErr(true);
                      return;
                    } else {
                      setDepositAmtErr(false);
                    }

                    // Format the number
                    const formattedAmount = depositAmount.toLocaleString(
                      'en-US',
                      {
                        maximumFractionDigits: 0,
                      }
                    );

                    setFormattedTotalAmount(formattedAmount);
                    setDepositAmount(depositAmount);

                    // Auto-update % field
                    if (offerPriceValue && offerPriceValue > 0) {
                      const calculatedPercent = (
                        (depositAmount / offerPriceValue) *
                        100
                      ).toFixed(0);
                      setDepositPercent(calculatedPercent);
                    } else {
                      setDepositPercent('0');
                    }

                    // ✅ Fix cursor after formatting
                    requestAnimationFrame(() => {
                      const digitsBeforeCursor = raw
                        .slice(0, cursorPos)
                        .replace(/\D/g, '').length;
                      let newCursor = 0;
                      let digitSeen = 0;

                      for (let i = 0; i < formattedAmount.length; i++) {
                        if (/\d/.test(formattedAmount[i])) digitSeen++;
                        newCursor++;
                        if (digitSeen === digitsBeforeCursor) break;
                      }

                      depositInputRef.current?.setSelectionRange(
                        newCursor,
                        newCursor
                      );
                    });
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        sx={{
                          minWidth: 'auto',
                          justifyContent: { xs: 'center', sm: 'flex-start' }, // Center for mobile, left for web
                          width: { xs: '30px', sm: 'auto' }, // Reduce width only in mobile
                        }}
                      >
                        <Typography
                          sx={{
                            background: 'transparent',
                            padding: { xs: '0 2px', sm: '0 10px' }, // Reduce padding in mobile only
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: { xs: '16px', sm: '18px', md: '20px' },
                            fontWeight: 600,
                            fontFamily: 'Poppins',
                            marginRight: matchessm ? -25 : 0,
                          }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                    sx: {
                      fontSize: { xs: '14px', sm: '16px', md: '20px' },
                      height: '50px',
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                      '& .MuiInputBase-input': {
                        paddingLeft: { xs: '2px', sm: 'inherit' }, // Reduce padding in mobile only
                        textAlign: { xs: 'center', sm: 'left' }, // Center text in mobile, left in web
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: { xs: '14px', sm: '16px', md: '20px' },
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                    },
                  }}
                  sx={{
                    width: { xs: '100%', sm: '80%' },
                    '& .MuiInputBase-input::placeholder': {
                      fontSize: { xs: '14px', sm: '16px', md: '20px' },
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                    },
                  }}
                />
              </Box>

              <span
                style={{
                  visibility: depositAmtErr ? 'visible' : 'hidden',
                  color: 'red',
                  fontFamily: 'Poppins',
                  fontSize: '14px',
                  marginTop: '8px',
                }}
              >
                Enter the valid percentage or amount
              </span>
            </Box>
          </Grid>

          <Grid
            xs={12}
            sx={flexStyle}
            style={{ flexWrap: matches400 && 'wrap' }}
          >
            <Typography sx={reqStyle}>Deposit Due:</Typography>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={['DatePicker']}
                  sx={{ overflow: 'hidden' }}
                >
                  <DatePicker
                    disableScrollLock
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={FromOgDate}
                    onChange={(newValue) => {
                      if (!newValue || !newValue.isValid()) {
                        setDepositDueErr(true);
                        return;
                      }
                      const today = dayjs().startOf('day');
                      const todayInSydney = dayjs()
                        .tz('Australia/Sydney')
                        .startOf('day');
                      const selectedDate = dayjs(newValue)
                        .tz('Australia/Sydney')
                        .startOf('day');

                      if (selectedDate.isBefore(todayInSydney)) {
                        setDepositDueErr(true);
                        return;
                      }
                      // ✅ All validations passed
                      setDepositDueErr(false);
                      setFromOgDate(newValue);
                      const backendDate = newValue.format('YYYY-MM-DD');
                      setDepositDue(backendDate);
                    }}
                    // minDate={dayjs()}
                    // minDate={dayjs().add(1, 'day')}
                    // minDate={dayjs().tz('Australia/Sydney').startOf('day')}
                    minDate={today}
                    maxDate={stageTwo ? today : undefined}
                    format="DD-MM-YYYY"
                    sx={{
                      '& .MuiInputBase-root': {
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: depositDueErr && '0.5px solid red',
                      },
                      '& .MuiPickersPopper-root': {
                        overflow: 'hidden', // Fix scrollbar issue
                      },
                    }}
                    slotProps={{
                      textField: {
                        InputProps: {
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              onClick={handleIconClick}
                              style={{ cursor: 'pointer' }}
                            >
                              <Calendarimg />
                            </InputAdornment>
                          ),
                          sx: {
                            fontSize: matches750 ? '14px' : '18px',
                            fontFamily: 'Poppins',
                          },
                        },
                        inputProps: {
                          onClick: () => setOpen(true), // Open picker when input field is clicked
                          sx: {
                            '::placeholder': {
                              fontSize: matches750 ? '14px' : '18px',
                              fontFamily: 'Poppins',
                            },
                          },
                        },
                      },
                      openPickerButton: {
                        sx: { display: 'none' }, // Hide default open button
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <span
                style={{
                  visibility: depositDueErr ? 'visible' : 'hidden',
                  color: 'red',
                  fontFamily: 'poppins',
                  fontSize: '14px',
                }}
              >
                You cannot enter a past date
                {/* Select current  Date */}
              </span>
            </Box>
          </Grid>
          <Grid
            xs={12}
            sx={flexStyle}
            style={{ flexWrap: matches400 && 'wrap' }}
          >
            <Typography sx={reqStyle}>Proposed Settlement:</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <Box>
                <TextField
                  type="number"
                  variant="outlined"
                  inputProps={{
                    maxLength: 3,
                    style: { fontFamily: 'Poppins' },
                    inputMode: 'numeric',
                    min: 0,
                  }}
                  value={depositSettlement}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 3) {
                      setDepositSettlement(value);
                      setDepositSettleErr(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    // Prevent invalid characters: e, E, +, -, .
                    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  InputProps={{
                    sx: {
                      fontSize: matches750 ? '14px' : '20px',
                      textAlign: 'center',
                      '&::placeholder': {
                        textAlign: 'center',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: matches750 ? '14px' : '20px',
                      textAlign: 'center',
                    },
                  }}
                  error={depositSettleErr}
                  sx={{
                    width: '80px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiOutlinedInput-input': {
                      textAlign: 'center',
                      padding: '10px 14px',
                      MozAppearance: 'textfield', // removes arrows in Firefox
                    },
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                      {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '5px',
                    },
                  }}
                />
                <span
                  style={{
                    visibility: depositSettleErr ? 'visible' : 'hidden',
                    color: 'red',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                  }}
                >
                  Enter Days
                </span>
              </Box>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: matches800 ? '12px' : '16px',
                  marginBottom: matches500 && '39px',
                }}
              >
                {Number(depositSettlement) === 1 ? 'day' : 'days'} after the
                exchanged contract date.
              </Typography>
            </Box>
          </Grid>

          <Grid
            xs={12}
            container
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
            sx={{
              gap: { xs: '10px', sm: '5px' },
              paddingX: { xs: '10px', sm: '0px' },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: '24px', sm: '20px', md: '24px' },
                fontWeight: 400,
                color: '#112347',
              }}
            >
              EFT Payment Details
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                pr: { xs: '0px', sm: '50px' },
                flexWrap: 'wrap',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: '14px', sm: '12px' },
                  color: toggleState ? '#112347' : '#9C9C9C',
                }}
              >
                Agency Trust
              </Typography>

              <Box
                onClick={handleToggleState}
                sx={{
                  width: '50px',
                  height: '25px',
                  background:
                    'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: toggleState ? 'flex-start' : 'flex-end',
                  padding: '3px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  boxShadow: 'inset 0px 0px 4px rgba(0,0,0,0.3)',
                }}
              >
                <Box
                  sx={{
                    width: '18px',
                    height: '18px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    transition: 'all 0.3s ease',
                  }}
                />
              </Box>

              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: '14px', sm: '12px' },
                  color: toggleState ? '#9C9C9C' : '#112347',
                }}
              >
                Legal Trust
              </Typography>
            </Stack>
          </Grid>
          <Grid container spacing={2} sx={flexStyle}>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: matches400 ? 'wrap' : 'nowrap',
              }}
            >
              <Typography
                sx={{
                  ...reqStyle,
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  fontWeight: 400,
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  minWidth: '150px',
                }}
              >
                Deposit Holder
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flex: 1,
                  marginTop: matches400 ? 1 : 0,
                  marginLeft: '15px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    color: '#000000',
                  }}
                >
                  Ray White Bondi Beach
                </Typography>
                {agentAgencyName && (
                  <Box>
                    <AgencyBadge name={agentAgencyName} />
                  </Box>
                )}
              </Box>
            </Grid>
            {/* Trust Account Name */}
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: matches400 ? 'wrap' : 'nowrap',
              }}
            >
              <Typography
                sx={{
                  ...reqStyle,
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  fontWeight: 400,
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  minWidth: '150px', // Adjust label width for consistent alignment
                }}
              >
                Trust Account Name:
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  marginTop: matches400 ? 1 : 0,
                  marginLeft: '15px',
                }}
              >
                <TextField
                  variant="outlined"
                  // placeholder="AJ Real Estate Trust Account"
                  // value={trustAccountName}
                  value="AJ Real Estate Trust Account"
                  // error={trustAccountNameErr}
                  // onChange={(e) => setTrustAccountName(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      fontSize: '16px',
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                    },
                  }}
                  sx={{
                    width: matches750 ? '100%' : '452px',
                    '& .MuiInputBase-input': {
                      fontSize: {
                        xs: '10px',
                        sm: '12px',
                        md: '16px',
                        lg: '16px',
                        xl: '16px',
                      },
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                      cursor: 'default',
                    },
                    '& .MuiOutlinedInput-root': {
                      cursor: 'default',
                    },
                  }}
                />
                <Tooltip
                  title={accountcopied ? 'Copied to clipboard' : ''}
                  open={accountcopied}
                  arrow
                >
                  <IconButton onClick={handleAccountCopy}>
                    <CopyIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>

            {/* BSB */}
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: matches400 ? 'wrap' : 'nowrap',
              }}
            >
              <Typography
                sx={{
                  ...reqStyle,
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  fontWeight: 400,
                  minWidth: '150px', // Adjust label width for consistent alignment
                }}
              >
                BSB:
              </Typography>
              <Box sx={{ flex: 1, marginLeft: '15px' }}>
                <TextField
                  variant="outlined"
                  value="019 1928"
                  InputLabelProps={{
                    sx: {
                      fontSize: '20px',
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                    },
                  }}
                  sx={{
                    width: matches750 ? '100%' : '452px',
                    '& .MuiInputBase-input': {
                      fontSize: {
                        xs: '10px',
                        sm: '12px',
                        md: '16px',
                        lg: '16px',
                        xl: '16px',
                      },
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                      cursor: 'default',
                    },
                    '& .MuiOutlinedInput-root': {
                      cursor: 'default',
                    },
                  }}
                />
                <Tooltip
                  title={bsbcopied ? 'Copied to clipboard' : ''}
                  open={bsbcopied}
                  arrow
                >
                  <IconButton onClick={handleBsbCopy}>
                    <CopyIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>

            {/* Account Number */}
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: matches400 ? 'wrap' : 'nowrap',
              }}
            >
              <Typography
                sx={{
                  ...reqStyle,
                  fontFamily: 'Poppins',
                  fontSize: '16px',
                  fontWeight: 400,
                  minWidth: '150px', // Adjust label width for consistent alignment
                }}
              >
                Account No:
              </Typography>
              <Box sx={{ flex: 1, marginLeft: '15px' }}>
                <TextField
                  variant="outlined"
                  value="0190 21928"
                  InputLabelProps={{
                    sx: {
                      fontSize: '20px',
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                    },
                  }}
                  sx={{
                    width: matches750 ? '100%' : '452px',
                    '& .MuiInputBase-input': {
                      fontSize: {
                        xs: '10px',
                        sm: '12px',
                        md: '16px',
                        lg: '16px',
                        xl: '16px',
                      },
                      fontWeight: 400,
                      fontFamily: 'Poppins',
                      cursor: 'default',
                    },
                    '& .MuiOutlinedInput-root': {
                      cursor: 'default',
                    },
                  }}
                />
                <Tooltip
                  title={accnocopied ? 'Copied to clipboard' : ''}
                  open={accnocopied}
                  arrow
                >
                  <IconButton onClick={handleAccNoCopy}>
                    <CopyIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          // marginTop={ matchessm ? "15px" : 5}
          marginBottom={'30px'}
          marginRight={'30px'}
        >
          <Grid item>
            <Button
              disabled={requestDepositLoader}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => {
                colseContractAprove();
                setDisplayExchange(true);
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
          >
            <Button
              disabled={requestDepositLoader || !isFormValid}
              variant="outlined"
              onClick={reqdepositvalidate}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: !isFormValid ? '#9c9c9c' : '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
              }}
            >
              Request
            </Button>
            {requestDepositLoader && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}
